if (window.membersScholarshipsInitialized) {
  console.warn("Members Scholarships JS already initialized");
} else {
  window.membersScholarshipsInitialized = true;
  (async function () {
    const PER_PAGE = 5;
    const COLLECTION = "scholarships";
    const cardsContainer = document.getElementById("mass-cards");
    if (!cardsContainer) return;
    if (typeof envConfig === "undefined") return;
    const BASE_URL = `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}`;
    const API_KEY = envConfig.TYPESENSE_SEARCH_ONLY_KEY;

    // State
    let activeAwardTypes = new Set();
    let activeEligibility = new Set();
    let searchQuery = "";
    let debounceTimer = null;
    let currentPage = 1;
    let totalFound = 0;
    let renderedCount = 0;
    let isLoading = false;
    let filtersBuilt = false;

    // Maps lifted to outer scope
    let awardTypeMap = new Map();
    let eligibilityMap = new Map();

    // DOM refs
    const pagination = document.getElementById("mass-pagination");
    const loadMoreBtn = document.getElementById("mass-load-more");
    const showLessBtn = document.getElementById("mass-show-less");
    const section = document.getElementById("mass-section");
    const searchInput = document.getElementById("mass-search");
    const searchContainer = document.getElementById("mass-search-container");
    const resultsPanel = document.getElementById("mass-results-panel");
    const resultsCount = document.getElementById("mass-results-count");
    const chipsContainer = document.getElementById("mass-chips-container");
    const clearSearchBtn = document.getElementById("mass-clear-search");
    const closeIconUrl = resultsPanel?.dataset.closeIcon || "";
    const themeUri = section?.dataset.themeUri || "";

    function scrollToSection() {
      if (!section) return;

      const offset = window.innerWidth < 1024 ? 40 : 60;

      const y =
        section.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
    searchContainer?.addEventListener("click", () => {
      searchInput?.focus();
    });

    function buildChip(label, onRemove) {
      const chip = document.createElement("span");
      chip.className =
        "w-auto flex items-center justify-between gap-[.625rem] p-2 !pl-[.625rem] md:!pl-[1.25rem] text-white text-p1 font-normal font-neutraface rounded-full bg-brand-dark-red";
      chip.innerHTML = `
        <span class="capitalize">${label}</span>
        <img src="${closeIconUrl}" alt="remove"
          class="w-[1.5625rem] h-[1.5625rem] object-contain object-center cursor-pointer flex-shrink-0">
      `;
      chip.querySelector("img").addEventListener("click", (e) => {
        e.preventDefault();
        onRemove();
      });
      return chip;
    }

    function updateResultsPanel() {
      const hasActivity =
        searchQuery.length > 0 ||
        activeAwardTypes.size > 0 ||
        activeEligibility.size > 0;

      if (!hasActivity) {
        resultsPanel.classList.add("hidden");
        resultsPanel.classList.remove("flex");
        return;
      }

      resultsPanel.classList.remove("hidden");
      resultsPanel.classList.add("flex");

      resultsCount.textContent = `${totalFound} Result${totalFound !== 1 ? "s" : ""}`;

      chipsContainer.innerHTML = "";

      if (searchQuery) {
        chipsContainer.appendChild(
          buildChip(searchQuery, () => {
            searchQuery = "";
            searchInput.value = "";
            triggerFilter();
            syncAllVisuals();
          }),
        );
      }

      activeAwardTypes.forEach((slug) => {
        const name = awardTypeMap.get(slug) || slug;
        chipsContainer.appendChild(
          buildChip(name, () => {
            activeAwardTypes.delete(slug);
            syncAllVisuals();
            triggerFilter();
          }),
        );
      });
    }

    clearSearchBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      searchQuery = "";
      searchInput.value = "";
      activeAwardTypes.clear();
      syncAllVisuals();
      triggerFilter();
    });

    function buildFilterBy() {
      const parts = [];
      if (activeAwardTypes.size > 0)
        parts.push(
          `members_eligibility_slugs:=[${[...activeAwardTypes].join(",")}]`,
        );
      return parts.join(" && ");
    }

    async function fetchPage(page) {
      const params = {
        q: searchQuery || "*",
        query_by:
          "title,description,requirements_title,requirements_text,additional_information_heading,additional_information_description,link_title",
        sort_by: "title:asc",
        per_page: PER_PAGE,
        prefix: false,
        num_typos: 0,
        drop_tokens_threshold: 0,
        typo_tokens_threshold: 0,
        page,
      };

      const filterBy = buildFilterBy();
      if (filterBy) params.filter_by = filterBy;

      const url =
        `${BASE_URL}/collections/${COLLECTION}/documents/search?` +
        new URLSearchParams(params);
      const res = await fetch(url, {
        headers: {
          "X-TYPESENSE-API-KEY": API_KEY,
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }

    function formatDeadline(doc) {
      if (doc?.deadline_time == null) {
        return doc?.deadline_label || "";
      }

      const hours = Math.floor(doc.deadline_time / 3600);
      const minutes = Math.floor((doc.deadline_time % 3600) / 60);
      const suffix = hours >= 12 ? "p.m." : "a.m.";
      const displayHour = hours % 12 || 12;
      const displayMinutes = String(minutes).padStart(2, "0");

      const dateObj = new Date(doc?.deadline_date * 1000);
      if (isNaN(dateObj.getTime())) {
        return doc?.deadline_label || "";
      }

      const datePart = dateObj.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });

      return `${displayHour}:${displayMinutes} ${suffix} ET on ${datePart}`;
    }

    function isDeadlineExpired(doc) {
      if (!doc?.deadline_date) return false;

      const time = doc.deadline_time != null ? doc.deadline_time : 86399;
      const deadlineUTC = (doc.deadline_date + time) * 1000;
      const now = new Date();
      const nowET = new Date(
        now.toLocaleString("en-US", { timeZone: "America/New_York" }),
      );

      return deadlineUTC < nowET.getTime();
    }

    // Applications are handled centrally in the BPA Scholarships System.
    const SCHOLARSHIPS_SYSTEM_URL =
      "https://bpa.org/member-gateway/bpa-scholarships/";

    function buildApplyLink(linkUrl, linkTitle) {
      if (!linkUrl) return "";
      const template = document.getElementById("mass-link-template");
      if (!template) return "";
      return template.innerHTML
        .replace("__LINK_URL__", linkUrl)
        .replace("__LINK_TITLE__", linkTitle);
    }

    function formatEligibility(names = []) {
      if (!names.length) return "";
      const cleaned = names.map((n) => n.replace(" Member", ""));
      const count = cleaned.length;
      if (count === 1) {
        return `${cleaned[0]} Member`;
      }
      return `${cleaned.join("/")} Members`;
    }

    function renderCards(docs, append = false) {
      if (!append) cardsContainer.innerHTML = "";

      if (!docs.length && !append) {
        cardsContainer.innerHTML = `
          <p class="w-full text-center py-12 text-brand-black opacity-60">
            No Members Scholarship found.
          </p>`;
        pagination.classList.add("hidden");
        return;
      }

      docs.forEach((doc) => {
        const deadlineDatePart = formatDeadline(doc);
        const expired = isDeadlineExpired(doc);
        let applyLink = "";

        if (!expired) {
          applyLink = buildApplyLink(SCHOLARSHIPS_SYSTEM_URL, "Apply Now");
        } else {
          applyLink = "";
        }
        const result = formatEligibility(doc.members_eligibility_names);

       const card = document.createElement("a");

card.href = SCHOLARSHIPS_SYSTEM_URL;

card.className =
  "w-full bg-brand-white-smoke p-6 flex flex-col justify-left items-center gap-6 self-stretch transform transition-transform duration-300 ease-in-out hover:scale-[1.01]";
        card.innerHTML = `
          <div class="w-full">
            <div class="w-full flex items-center max-md:flex-col justify-between gap-4 border-b border-brand-warm-beige mb-3 pb-3">
              <span class="text-left text-[1.5625rem] leading-[2.0625rem] max-md:text-center text-brand-dark-blue font-neutraface font-semibold">
                ${doc.title || ""}
              </span>
              ${applyLink}
            </div>

            ${
              doc.description
                ? `<div class="w-full htmlBlock text-brand-black htmlBlock-para-style">
                      ${doc.description}
                    </div>`
                : ""
            }
          </div>

          <div class="w-full grid-cols-1 lg:grid-cols-2 grid gap-6">
            <div class="w-full rounded-md bg-brand-light-red px-6 pb-4 pt-3 flex flex-col gap-2 justify-center">

              ${
                deadlineDatePart
                  ? `
              <div class="flex items-center gap-6 py-[.1875rem]">
                <img src="${calendarIconUrl}"
                  alt="calendar-icon" class="w-6 h-6 shrink-0">
                <span class="font-neutraface font-semibold text-p1 leading-[1.5625rem] text-brand-dark-red break-words">
                  ${deadlineDatePart}
                </span>
              </div>`
                  : ""
              }

              ${
                result
                  ? `
              <div class="flex items-center gap-6 py-[.1875rem]">
                <img src="${contactIconUrl}"
                  alt="contact-icon" class="w-6 h-6 shrink-0">
                <div class="font-neutraface font-semibold text-p1 leading-[1.5625rem] text-brand-dark-red break-words">
                  ${doc.number_of_members ? `<span>${doc.number_of_members}</span> ` : ""}${result}
                </div>
              </div>`
                  : ""
              }

            </div>

            ${
              doc.featured_image
                ? `
            <div class="w-full rounded-md bg-brand-blue-gray px-6 py-3 flex items-center gap-6">
              <span class="font-neutraface font-semibold text-p1 leading-[1.5625rem] text-brand-dark-blue pr-6 w-max py-[.5625rem] border-r border-brand-light-sky-blue">
                Partner
              </span>
              <img
                src="${doc.featured_image}"
                alt="partner-logo"
                class="w-auto mx-auto object-center object-contain h-[3.5rem] overflow-hidden"
              />
            </div>`
                : ""
            }
          </div>
        `;

        cardsContainer.appendChild(card);
      });
    }

    function updatePagination() {
      const allLoaded = renderedCount >= totalFound;
      if (totalFound <= PER_PAGE) {
        pagination.classList.add("hidden");
        return;
      }
      pagination.classList.remove("hidden");
      pagination.classList.add("flex");
      loadMoreBtn.classList.toggle("hidden", allLoaded);
      showLessBtn.classList.toggle("hidden", !allLoaded);
    }

    async function loadFresh() {
      if (isLoading) return;
      isLoading = true;

      cardsContainer.innerHTML = `
        <div class="w-full min-h-[7.5rem] flex items-center justify-center">
          <div class="flex flex-col items-center gap-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24">
              <g stroke="#C8102E" stroke-width="1">
                <circle cx="12" cy="12" r="9.5" fill="none" stroke-linecap="round" stroke-width="3">
                  <animate attributeName="stroke-dasharray" calcMode="spline" dur="1.5s" values="0 150;42 150;42 150;42 150" repeatCount="indefinite"/>
                  <animate attributeName="stroke-dashoffset" calcMode="spline" dur="1.5s" values="0;-16;-59;-59" repeatCount="indefinite"/>
                </circle>
                <animateTransform attributeName="transform" dur="2s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/>
              </g>
            </svg>
            <span class="text-brand-black font-neutraface text-[1.25rem] font-normal">Loading Members Scholarships...</span>
          </div>
        </div>`;

      pagination.classList.add("hidden");
      pagination.classList.remove("flex");

      try {
        currentPage = 1;
        renderedCount = 0;
        const data = await fetchPage(1);
        totalFound = data.found || 0;
        const docs = data.hits?.map((h) => h.document) || [];
        renderedCount = docs.length;

        renderCards(docs, false);
        updatePagination();
        updateResultsPanel();

        if (!filtersBuilt) {
          await fetchAllForFilters();
          filtersBuilt = true;
        }
      } catch (err) {
        console.error("Load failed:", err);
        cardsContainer.innerHTML = `<p class="w-full text-center py-12 text-red-600">Could not load Members Scholarships. Please try again.</p>`;
      } finally {
        isLoading = false;
      }
    }

    async function loadMore() {
      if (isLoading) return;
      isLoading = true;
      loadMoreBtn.textContent = "Loading...";
      loadMoreBtn.disabled = true;

      try {
        currentPage++;
        const data = await fetchPage(currentPage);
        const docs = data.hits?.map((h) => h.document) || [];
        renderedCount += docs.length;
        renderCards(docs, true);
        updatePagination();
      } catch (err) {
        console.error("Load more failed:", err);
        currentPage--;
      } finally {
        loadMoreBtn.textContent = "Load More";
        loadMoreBtn.disabled = false;
        isLoading = false;
      }
    }

    async function showLess() {
      await loadFresh();
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    function updateSelectedText(spanId, activeSet, defaultText, nameMap) {
      const span = document.getElementById(spanId);
      if (!span) return;
      if (activeSet.size === 0) {
        span.textContent = defaultText;
      } else {
        const names = [...activeSet].map((slug) => nameMap?.get(slug) || slug);
        span.textContent = names.join(", ");
      }
    }

    function syncAllVisuals() {
      document
        .querySelectorAll("#mass-members_eligibility-filters [data-slug]")
        .forEach((btn) => {
          const active = activeAwardTypes.has(btn.dataset.slug);
          const box = btn.querySelector(".checkbox-box");
          const checkmark = btn.querySelector(".checkmark");
          box.classList.toggle("bg-brand-dark-red", active);
          box.classList.toggle("border-brand-dark-red", active);
          box.classList.toggle("bg-white", !active);
          box.classList.toggle("border-brand-warm-gray", !active);
          checkmark.classList.toggle("hidden", !active);
        });

      updateSelectedText(
        "members_eligibility-selected",
        activeAwardTypes,
        "All Members Scholarships Types",
        awardTypeMap,
      );

      updateResultsPanel();
    }

    function buildCheckbox(slug, name, activeSet, onChange) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.dataset.slug = slug;
      btn.className = "w-full flex items-center justify-start gap-2 md:gap-3";

      const isActive = activeSet.has(slug);
      btn.innerHTML = `
        <div class="checkbox-box w-6 h-6 shrink-0 border ${isActive ? "bg-brand-dark-red border-brand-dark-red" : "border-brand-warm-gray bg-white"} rounded flex items-center justify-center transition-colors">
          <svg class="checkmark ${isActive ? "" : "hidden"} w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <p class="text-p1 text-brand-black font-normal !my-0">${name}</p>
      `;

      btn.addEventListener("click", () => {
        if (activeSet.has(slug)) {
          activeSet.delete(slug);
        } else {
          activeSet.add(slug);
        }
        syncAllVisuals();
        onChange();
        scrollToSection();
      });

      return btn;
    }

    async function fetchAllForFilters() {
      try {
        const url =
          `${BASE_URL}/collections/${COLLECTION}/documents/search?` +
          new URLSearchParams({
            q: "*",
            query_by: "title",
            per_page: 250,
            page: 1,
          });

        const res = await fetch(url, {
          headers: {
            "X-TYPESENSE-API-KEY": API_KEY,
          },
        });
        const data = await res.json();
        const docs = data.hits?.map((h) => h.document) || [];

        docs.forEach((doc) => {
          doc.members_eligibility_names?.forEach((name, i) => {
            const slug = doc.members_eligibility_slugs?.[i] || "";
            if (slug) awardTypeMap.set(slug, name);
          });
        });

        const awardSection = document.getElementById(
          "mass-members_eligibility-section",
        );
        if (awardTypeMap.size > 0) {
          awardSection.classList.remove("hidden");
          const awardFilters = document.getElementById(
            "mass-members_eligibility-filters",
          );
          awardTypeMap.forEach((name, slug) => {
            awardFilters.appendChild(
              buildCheckbox(slug, name, activeAwardTypes, triggerFilter),
            );
          });
        }

        syncAllVisuals();
      } catch (err) {
        console.error("Filter build failed:", err);
      }
    }

    function triggerFilter() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(loadFresh, 300);
    }

    searchInput?.addEventListener("input", (e) => {
      searchQuery = e.target.value.trim();
      updateResultsPanel();
      triggerFilter();
      scrollToSection();
    });

    loadMoreBtn.addEventListener("click", loadMore);
    showLessBtn.addEventListener("click", showLess);

    await loadFresh();
  })();
}
